import { render, staticRenderFns } from "./LocationLimitTable.vue?vue&type=template&id=4aef696a"
import script from "./LocationLimitTable.vue?vue&type=script&lang=js"
export * from "./LocationLimitTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports